export default __webpack_public_path__ + "static/media/UTPL_Financial_March_2026.39eff13e.pdf";